module.exports = __webpack_public_path__ + "img/carnetW.1e36b3db.png";